import axios from 'axios'
import { CATALOGO_ENDPOINT } from '../../endpoints'
import * as FileSaver from 'file-saver'
import { XML_TYPE } from 'Utilities'

const REPORT_NAME_PUBLISH_PRICE = 'Precio de publicaciones.xlsx'
const REPORT_NAME_PRICES = 'Precios.xlsx'
const REPORT_NAME_SAVINGS_PLAN = 'Precioplandeahorro.xlsx'
const USED_CAR_TYPE = 'Usados'
const ZERO_KM_CAR_TYPE = '0Km'
const SAVINGS_PLAN_TYPE = 'SavingsPlan'
const PUBLISH_PRICE_TYPE = 'publishPrice'
export async function getPriceUpdateReport(
  carLotId,
  bussinessUnitType,
  priceType,
  includeNonPublished
) {
  let reportName = ''
  if (bussinessUnitType === SAVINGS_PLAN_TYPE) {
    reportName = REPORT_NAME_SAVINGS_PLAN
  } else if(bussinessUnitType === ZERO_KM_CAR_TYPE || bussinessUnitType === USED_CAR_TYPE) {
    reportName = priceType === PUBLISH_PRICE_TYPE ? REPORT_NAME_PUBLISH_PRICE : REPORT_NAME_PRICES
  }
  const report = await axios.get(
    `${CATALOGO_ENDPOINT}/generatePriceExcel/${carLotId}/${bussinessUnitType}/${priceType}/${includeNonPublished}`,
    {
      responseType: 'blob',
      timeout: 300000 // 5 minutos
    }

  )
  if (report) {
    const file = new Blob([report.data], {
      type: XML_TYPE
    })
    FileSaver.saveAs(file, reportName)
  }
}